import React from 'react';
import { TabList, Tab, TabLink } from './style';

const tabs = [
  { path: `/dashboard/magic/agent`, name: 'Catalog' },
  { path: `/dashboard/magic/agent/settings`, name: 'Settings' }
];

const Tabs = () => {
  return (
    <TabList>
      {tabs.map(item => (
        <Tab key={item.path}>
          <TabLink to={item.path} exact>
            {item.name}
          </TabLink>
        </Tab>
      ))}
    </TabList>
  );
};

export default Tabs;
